import { getWeb3Connector } from '@binance/w3w-web3-connector';
import { RPC_CONFIG } from 'modules/api/rpcConfig';

type BinanceWeb3WalletProvider = any;

/**
 * Connect to Binance Web3 wallet.
 *
 * @returns Binance Web3 wallet provider.
 */
export async function binanceWeb3Connector(): Promise<BinanceWeb3WalletProvider> {
  const Connector = getWeb3Connector();

  const supportedChainIds = Object.keys(RPC_CONFIG).map(item => Number(item));

  const binanceConnector = new Connector({
    showQrCodeModal: true,
    supportedChainIds,
    rpc: {
      ...RPC_CONFIG,
    },
  });

  await binanceConnector.activate();

  return binanceConnector.getProvider();
}
